class FlowFormBuilderDesignModel {
    id?: number;
    requestId?: number;
    flowCaptionId?: number;
    radPeygirId?: string;
    flowId?: number;
    flowTitle?: string;
  isImage?: boolean;
      i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  colname: string;
  ftype: string;
  fnum: string;
  flabel: string;
  frequired: boolean;
  faccess: string;
  fvalue: string;
  fimg: string;
  ffields: string;
  ffieldstxt: string;
  ffontweight: string;
  ffontstyle: string;
  ffontsize: string;
  ffontfamily: string;
  fcolor: string;
    isActive?: boolean;

    constructor(
        id: number,
    requestId: number,
    flowCaptionId: number,
    radPeygirId: string,
    flowId: number,
    flowTitle: string,
  isImage: boolean,
    i: string,
  x: number,
  y: number,
  w: number,
  h: number,
  colname: string,
  ftype: string,
  fnum: string,
  flabel: string,
  frequired: boolean,
  faccess: string,
  fvalue: string,
  fimg: string,
  ffields: string,
  ffieldstxt: string,
  ffontweight: string,
  ffontstyle: string,
  ffontsize: string,
  ffontfamily: string,
  fcolor: string,
  isActive: boolean,
    ) {
        this.id = id;
        this.requestId = requestId;
        this.flowCaptionId = flowCaptionId;
        this.radPeygirId = radPeygirId;
        this.flowId = flowId;
        this.flowTitle = flowTitle;
        this.flowTitle = flowTitle;
        this.isImage = isImage;
        this.i = i;
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
        this.colname = colname;
        this.ftype = ftype;
        this.fnum = fnum;
        this.flabel = flabel;
        this.frequired = frequired;
        this.faccess = faccess;
        this.fvalue = fvalue;
        this.fimg = fimg;
        this.ffields = ffields;
        this.ffieldstxt = ffieldstxt;
        this.ffontweight = ffontweight;
        this.ffontstyle = ffontstyle;
        this.ffontsize = ffontsize;
        this.ffontfamily = ffontfamily;
        this.fcolor = fcolor;
        this.isActive = isActive;
    }

    public static fromJson(json: any): FlowFormBuilderDesignModel {
        return new FlowFormBuilderDesignModel(
            json["id"],
            json["requestId"],
            json["flowCaptionId"],
            json["radPeygirId"],
            json["flowId"],
            json["flowTitle"],
              json["isImage"],
              json["i"],
            json["x"],
            json["y"],
            json["w"],
            json["h"],
            json["colname"],
            json["ftype"],
            json["fnum"],
            json["flabel"],
            json["frequired"],
            json["faccess"],
            json["fvalue"],
            json["fimg"],
            json["ffields"],
            json["ffieldstxt"],
            json["ffontweight"],
            json["ffontstyle"],
            json["ffontsize"],
            json["ffontfamily"],
            json["fcolor"],
            json["isActive"]
        );
    }
}
export interface FlowFormBuilderDesignGetPayloadFilterModel {
    id?: number;
    fieldName?: string;
    flowId?: number;
    isActive?: number;
}

export interface FlowFormBuilderDesignGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: FlowFormBuilderDesignGetPayloadFilterModel;
}

export class FlowFormBuilderDesignPayloadListModel {
   flowId?: number;
   peygirId?: string;
   radFlowWorkTypeId?: number;
   radAccountId?: number;
   FlowFormBuilderDesignModelList: FlowFormBuilderDesignPayloadModel[];

    constructor(
        flowId: number,
        peygirId: string,
        radFlowWorkTypeId: number,
        radAccountId: number,
      
           FlowFormBuilderDesignModelList: FlowFormBuilderDesignPayloadModel[],
    ) {
        this.flowId = flowId;
        this.peygirId = peygirId;
        this.radFlowWorkTypeId = radFlowWorkTypeId;
        this.radAccountId = radAccountId;
        this.FlowFormBuilderDesignModelList = FlowFormBuilderDesignModelList;

    }

}


export interface FlowFormBuilderDesignPayloadModel {
  id?: number;
  flowId?: number;
  i?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  colname?: string;
  ftype?: string;
  fnum?: string;
  flabel?: string;
  frequired?: boolean;
  faccess?: string;
  fvalue?: string;
  fimg?: string;
  ffields?: string;
  ffieldstxt?: string;
  ffontweight?: string;
  ffontstyle?: string;
  ffontsize?: string;
  ffontfamily?: string;
  fcolor?: string;
  isActive?: boolean;


}
export default FlowFormBuilderDesignModel;
